<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar o perda em ciclo de código <b>{{this.entry.code}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(periodLoss) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_PERIOD_LOSS_MUTATION,
          variables: {
            id: periodLoss.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyPeriodLoss.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_PERIOD_LOSS_MUTATION = gql `
  mutation($id: ID!) {
    destroyPeriodLoss(id: $id) {
      periodLoss {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>